import type {
  DealOperationsConfirmedParams,
  DealRowActionPayload,
  UseDealOperations,
} from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import { useDealsDownload } from '@openx/components-deal/lib/utils/hooks/useDealsDownload.tsx';
import { useDealsArchive } from './useDealsArchive.ts';
import { useDealsClone } from './useDealsClone.ts';
import { useDealUpdateStatus } from './useDealUpdateStatus.tsx';

export const useDealOperations: UseDealOperations = () => {
  const { pause: pauseDeals, resume: resumeDeals } = useDealUpdateStatus();
  const { archive: deleteDeals } = useDealsArchive();
  const { download: downloadDeals } = useDealsDownload();
  const { clone: cloneDeals } = useDealsClone();

  const onConfirmed = async <T, V extends DealRowActionPayload = DealRowActionPayload>({
    setLoading,
    onFinish,
    deals,
    action,
    actionCallback,
  }: DealOperationsConfirmedParams<T, V>) => {
    try {
      setLoading(action);
      const actionResults = await actionCallback(deals);
      setLoading(null);
      onFinish?.(actionResults);
    } catch {
      setLoading(null);
    }
  };

  return { cloneDeals, deleteDeals, downloadDeals, onConfirmed, pauseDeals, resumeDeals };
};
